import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  footer: {
    backgroundColor: theme.palette.background.paper,
    bottom: 0,
    width: '100vw',
    display: 'flex',
    'flex-direction': 'row',
    'justify-content': 'space-between',
    'align-items': 'center',
  },
  footerElement: {
    "margin": '5px 20px',
    "font-size": "10",
    "font-weight": "300",
  },
  a: {
    textDecoration: 'none',
    "&:hover, &:focus": {
      fontWeight: 400
    }
  },
}));

export default function Footer(props) {
  const classes = useStyles();
  const { description, title } = props;

  return (
    <footer className={classes.footer}>
      <p className={classes.footerElement}>
        {title}
      </p>
      <p className={classes.footerElement}>
        {'Copyright © Jules Civel & Gabriel Leclerc - '}
        {new Date().getFullYear()}
      </p>
      <p className={classes.footerElement}>
        {description}
      </p>
    </footer>
  );
}

Footer.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string,
};
